import React, { use, useState } from "react";
import moment from "moment";
import ReactTable from "react-table";
import { Cell } from "recharts";
import { notificarMsg } from "../Almacenes/AlmacenNotify";

const CALENDAR_STYLE = {
  border: "0.5px solid #acacac",
  borderRadius: "25px",
  outline: "none",
  flexBasis: "50%",
  alignSelf: "center",
};

export default function() {

    const [desde, setDesde] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [hasta, setHasta] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [filtrarPor, setFiltrarPor] = useState("FechaRegistro");
      const [currentPedidoId, setCurrentPedidoId] = useState(undefined);
    const [receta, setReceta] = useState([]);

    const [user, setUser] = useState(undefined);
    const [sucursales, setSucursales] = useState([]);
    const [sucursalInfo, setSucursalInfo] = useState({
        Nombre: "Sucursal del usuario en sesión"
    });

      const [currentSucursalId, setCurrentSucursalId] = useState(undefined);
      const [currentAlmacenId, setCurrentAlmacenId] = useState(undefined);
      const [canChangeSucursal, setCanChangeSucursal] = useState(false);

    const [turnoCaja, setTurnoCaja] = useState(null);
    const [aperturarCaja, setAperturarCaja] = useState(false);
    const [puedeRegistrar, setPuedeRegistrar] = useState(false);
    const [alertaApertura, setAlertaApertura] = useState(false);

  const fetchAlmacen = async () => {
    const response = await fetch(`/api/almacenes/AlmacenBySucursal?idSucursal=${currentSucursalId}`);
    const {results, } = await response.json();
    const { IdAlmacen } = results[0];
    setCurrentAlmacenId(IdAlmacen);
  }



  const getTurno = async () => {
    try {
        const response = await fetch(`/api/cajas/verificar/Turno`);
        const dataTurno = await response.json();
        return  dataTurno
    } catch (e) {
        return { Turno: null}
    }
}



      const getAperturarCaja = async ()  => {
        let permiso = false;
    
        try {
            const response = await fetch(`/api/cajas/user/validar`);
            const data = await response.json();
            permiso = Boolean(data.ValidarUser)
        } catch (e) {
            console.error(e)
        }
    
        setAperturarCaja(permiso);
    
        if (!permiso) {
          setPuedeRegistrar(false);
          return;
        }
    
        const turnoInfo = await getTurno();
    
        if (!turnoInfo.Turno) {
            setPuedeRegistrar(false);
            notificarMsg("Se ha detectado que la caja se encuentra cerrada", "warning")
            return
        }
    
        const turno = turnoInfo.Turno[0][0];
    
        const fechaInicio = moment(turno.FechaInicio).add(-5, 'hours').format("YYYY-MM-DD")
        const now = moment().format("YYYY-MM-DD");
    
        setTurnoCaja(turno);
        setPuedeRegistrar((fechaInicio == now))
        setAlertaApertura(!(fechaInicio == now))
    }




    return (
        <>
            <div className="ventas-fpay-section">
                <div className="caja-fondo-blanco-m-2 mt-3" style={{ width: '40%', marginLeft: '30%' }}>
                    <div className="justify-content-center d-flex">
                        <span className="align-self-center letra-fecha-fpay">Desde: </span>
                        <input
                        type="date"
                        onChange={(e) => setDesde(e.target.value)}
                        value={desde}
                        className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                        style={CALENDAR_STYLE}
                        />
                        <span className="align-self-center letra-fecha-fpay">Hasta: </span>
                        <input
                        type="date"
                        onChange={(e) => setHasta(e.target.value)}
                        defaultValue={hasta}
                        className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                        style={CALENDAR_STYLE}
                        />
                    </div>
                    <div className="justify-content-center d-flex">
                        <span className="letra-fecha-fpay">Filtrar por: </span>
                        <select className="form-control w-50 ml-3" value={filtrarPor} onChange={e => setFiltrarPor(e.target.value)}>
                        <option value="FechaRegistro">Fecha de registro</option>
                        <option value="FechaEntrega">Fecha de entrega</option>
                        </select>
                    </div>
                </div>

                <div className="pt-3 container">
                    <div className={`col-12 no-pad ${canChangeSucursal ? '' : 'caja-fondo-blanco-m-2'}`}>
                        {canChangeSucursal ?
                            <div className="caja-fondo-blanco-m-2">
                                <label className="sucursal-text-color" htmlFor="sucursales">Seleccione una sucursal</label>
                                <select value={currentSucursalId} name="sucursales" id="sucursales"
                                        className="w-100 select-search-box__search"
                                        onChange={e => setCurrentSucursalId(e.target.value)}>
                                {sucursales.map((s, i) => <option key={i} value={s.IdSucursal}>{s.Nombre}</option>)}
                                </select>
                            </div> : <label className="sucursal-text-color container">{sucursalInfo.Nombre}</label>}
                    </div>
                </div>
                
                <div className="container mt-5">
                    <div className="d-flex justify-content-end seccion-btn-generar">
                        <button type="button" className="ml-3 btn btn-outline-primary btn-verde-mfp mb-2">Registrar</button>
                    </div>
                    <div className="mt-3">
                        <ReactTable 
                            filterable
                            defaultFilterMethod={(filter, row) =>
                                String(row[filter.id]) === filter.value
                            }
                            columns ={[
                                {
                                    columns:[
                                        {
                                            Headers:"Acciones",
                                            headerClassName:"",
                                            width:250,
                                            Cell:(row) =>{
                                                return <div>
                                                    {!!turnoCaja && row.original.IdCaja === turnoCaja.IdCaja && <button
                                                        className="btn btn-success btn-verde-mfp-letra-normal"
                                                        onClick={() => setCurrentPedidoId(row.original.IdPedido)}
                                                        >
                                                        Gestionar
                                                    </button>}
                                                    <button type="button" className="ml-3 btn btn-outline-primary btn-verde-mfp mb-2">Imprimir</button>
                                                </div>
                                            }
                                        },
                                        {
                                            Headers:"Fecha de registro",
                                            id: "FechaEmision",
                                            headerClassName:"",
                                            width: 125,
                                            filterAll: true,
                                            accessor: (d) => moment(d.FechaEmision).format("DD/MM/YYYY"),
                                        },
                                        {
                                            Headers:"Fecha de registro",
                                            id: "FechaEmision",
                                            headerClassName:"",
                                            width: 125,
                                            filterAll: true,
                                            accessor: (d) => moment(d.FechaEmision).format("DD/MM/YYYY"),
                                        },
                                        {
                                            Header: "Caja",
                                            id: "Caja",
                                            headerClassName: "",
                                            width: 175,
                                            filterAll: true,
                                            accessor: (d) => d.NombreCaja,
                                        },
                                        {
                                            Header: "Estado",
                                            id: "Estado",
                                            accessor: (d) => d.Estado,
                                            headerClassName: "",
                                            width: 150,
                                            filterAll: true,
                                            Cell: (row) => (
                                            <span className={`badge ${row.original.Estado === 'COMPLETADO'? 'badge-success' : 'badge-danger' }`}>{ row.original.Estado }</span>
                                            ),
                                        },
                                        {
                                            Header: "Fecha de entrega",
                                            id: "FechaEntrega",
                                            headerClassName: "",
                                            width: 200,
                                            filterAll: true,
                                            accessor: (d) => {
                                            const fecha = moment(d.FechaEntrega);
                    
                                            let label = fecha.fromNow();
                    
                                            if (fecha.isSame(new Date(), "day")) {
                                                label = "Hoy";
                                            }
                    
                                            if (fecha.isSame(moment().subtract(1, "day"), "day")) {
                                                label = "Ayer";
                                            }
                    
                                            if (fecha.isSame(moment().add(1, "day"), "day")) {
                                                label = "Mañana";
                                            }
                    
                                            return `${fecha.format("DD/MM/YYYY")} (${label})`;
                                            },
                                        }
                                    ]
                                }
                            ]}
                            defaultPageSize={5}
                            //pageSize={10}
                            className="-striped -highlight"
                            // Text de paginación
                            previousText="Anterior"
                            nextText="Siguiente"
                            loadingText="Cargando..."
                            noDataText="No se encontraron registros"
                            pageText="Página"
                            ofText="de"
                            rowsText="filas"
                            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                        
                        />
                    </div>

                </div>


            </div>
        </>
    )
}